import tutorialChartsTab from './tutorial/chats.js';
import dashboardLayout from './tutorial/dashboard-layout.js';
import tutorialBoard from './tutorial/board/board.js';
import calendarLayout from './tutorial/calendar-layout.js';
import datagridLayout from './tutorial/datagrid-layout.js';
import formsLayout, { dialog as formDialog } from './tutorial/forms-layout.js';
import elementsLayout, { startProgressBars } from './tutorial/elements-layout.js';
import { startVuMicrophoneDemo } from './tutorial/vu-microphone-demo.js';
import './tutorial/tools.js';

/**
 * TUTORIAL DA PLATFORM
 *
 * Este arquivo é propositalmente pequeno.
 *
 * Responsabilidade dele:
 * 1. criar as abas principais;
 * 2. colocar cada família na aba correta;
 * 3. iniciar comportamentos auxiliares que dependem dos componentes renderizados.
 *
 * Onde aprender cada coisa:
 * - Gráficos: tutorial/charts.js
 * - Layout de gráficos: tutorial/charts-layout.js
 * - Dashboard: tutorial/dashboard-layout.js
 * - Board: tutorial/board/board.js (dados mockados em tutorial/board-data.js)
 * - DataGrid: tutorial/datagrid.js
 * - Campos de formulário: tutorial/forms.js
 * - Layout de formulários: tutorial/forms-layout.js
 * - Elementos: tutorial/elements.js
 * - Layout de elementos: tutorial/elements-layout.js
 * - Calendário: tutorial/calendar-layout.js
 */

const mountTutorial = async () => {
  /**
   * A navegação principal do tutorial.
   *
   * Não coloque exemplos diretamente neste array. Cada aba deve receber o módulo
   * responsável pela sua própria família.
   */
  const tutorialTabs = await create([
    {
      element: 'group',
      parent: 'main',
      type: 'tab',
      style: { width: '100%' },
      groups: [
        {
          legend: 'dic.tutorial.tabs.graphics',
          active: true,
          isGrid: true,
          content: [tutorialChartsTab]
        },
        {
          legend: 'dic.tutorial.tabs.dashboard',
          isGrid: false,
          content: [dashboardLayout]
        },
        {
          legend: 'dic.tutorial.tabs.board',
          isGrid: true,
          content: [tutorialBoard]
        },
        {
          legend: 'dic.tutorial.tabs.calendar',
          isGrid: true,
          content: calendarLayout
        },
        {
          legend: 'dic.tutorial.tabs.datagrid',
          isGrid: true,
          content: [datagridLayout]
        },
        {
          legend: 'dic.tutorial.tabs.forms',
          isGrid: true,
          content: formsLayout
        },
        {
          legend: 'dic.tutorial.tabs.elements',
          isGrid: true,
          content: [elementsLayout]
        }
      ]
    }
  ]);

  /**
   * A demonstração de progress/meter só deve começar quando Elementos estiver
   * realmente visível. Isso evita que a animação termine enquanto outra aba está
   * aberta e garante largura real para os meters múltiplos.
   */
  const elementsTabLabel = window?.dic?.tutorial?.tabs?.elements;
  const elementsTab = [...(tutorialTabs?.querySelectorAll('.tab-link') || [])]
    .find((tab) => tab.textContent.trim() === elementsTabLabel);

  elementsTab?.addEventListener('click', () => {
    requestAnimationFrame(() => startProgressBars());
  });

  /**
   * O group de tabs ainda ativa a primeira aba por um ciclo posterior.
   * No tutorial fazemos isso assim que o grupo terminou de montar para que
   * nenhum conteúdo posterior apareça antes de Gráficos no primeiro frame.
   */
  tutorialTabs?.querySelector('.tab-link')?.click();

  /**
   * Os medidores de áudio do tutorial recebem fontes reais. Entrada física
   * (microfone/interface) e captura de aba ficam isoladas nos módulos da pasta
   * tutorial; aqui apenas iniciamos a integração depois que os charts existem.
   */
  requestAnimationFrame(() => startVuMicrophoneDemo());

  /**
   * O diálogo usado pelo exemplo de CEP precisa existir no body porque ele é
   * aberto pelo suffix do campo. Ele é declarado em forms.js, mas é montado aqui
   * fora da tab para não herdar o parent do conteúdo da aba.
   */
  await create([
    formDialog
  ]);
};

export default mountTutorial;
